import React, {useMemo} from "react";
import {Autocomplete, Box, TextField} from "@mui/material";
import {menuItemsInfo} from "../editMenuItems";
import {UI, rgba} from "../../uiTokens";
import {fieldSx} from "../editMenuStyles";
import {SectionHeader, SubSectionHeader} from "../components/EditMenuSection";
import {SettingsCustomParams} from "../components/SettingsCustomParams";

export const SettingsToolsTab = ({node, setNode, onUpdate, project}) => {
    const onChangeData = (key, value) => {
        setNode(prev => {
            const state = {...node};
            state.data[key] = value;
            return state;
        });
    };

    const {primary, secondary} = menuItemsInfo.settings_tools;

    const selectedTools = useMemo(() => {
        return project?.tools?.filter(i => node?.data?.tools && node?.data?.tools?.includes(i?.id)) || [];
    }, [node?.data?.tools, project?.tools]);

    return (
        <>
            <SectionHeader title={primary} description={secondary}/>

            <Box>
                <SubSectionHeader title="Select function to execute"/>
                <Autocomplete
                    multiple
                    size="small"
                    options={project?.tools || []}
                    getOptionLabel={option => option?.function?.name || ""}
                    isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                    value={selectedTools || []}
                    onChange={(e, newValue) => onChangeData("tools", newValue?.map(i => i?.id))}
                    slotProps={{
                        paper: {
                            sx: {
                                mt: 0.5,
                                borderRadius: "10px",
                                border: `1px solid ${rgba(UI.accent, 0.16)}`,
                                boxShadow: UI.shadow,
                            },
                        },
                    }}
                    renderInput={(props) => <TextField {...props} size="small" label="Functions" sx={{mt: 0.75, ...fieldSx}}/>}
                />
            </Box>

            <SettingsCustomParams node={node} setNode={setNode} onUpdate={onUpdate}/>
        </>
    );
};
